import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/lib/constants";
import { useLang } from "@/i18n/LanguageContext";
import { getLegalUI, getLegalDoc } from "@/i18n/legal";

export default function Legal({ type }) {
  const { lang } = useLang();
  const ui = getLegalUI(lang);
  const { updated, sections } = getLegalDoc(type, lang);
  const titleMap = { privacy: ui.privacy, cookie: ui.cookie, terms: ui.terms };

  return (
    <div className="grain min-h-screen bg-[#050505]">
      <header className="sticky top-0 z-40 bg-black/60 backdrop-blur-2xl border-b border-white/10">
        <div className="mx-auto max-w-[900px] px-5 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo"><img src={LOGO_URL} alt="AURA+" className="h-8 w-auto mix-blend-screen opacity-95" /></Link>
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft size={16} /> {ui.backHome}
          </Link>
        </div>
      </header>

      <main data-testid={`legal-${type}`} className="mx-auto max-w-[900px] px-5 md:px-8 py-16 md:py-24">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{ui.legalLinks}</span>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-white tracking-tight mt-4">{titleMap[type]}</h1>
        <p className="text-sm text-zinc-600 mt-3">{ui.updated}: {updated}</p>

        <div className="mt-12 space-y-10">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-white mb-3">{s.h}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
